<div class="public-layout">
    <app-header-public [showNavToggle]="false"></app-header-public>
    <div class="container">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>